document.querySelectorAll('[data-restock-toggle]').forEach(function (root) {
  var sectionId = root.dataset.sectionId;
  if (!sectionId) return;

  var addToCartGroup = document.getElementById('ProductFormButtons-' + sectionId);
  var restockGroup = document.getElementById('RestockAction-' + sectionId);
  if (!addToCartGroup || !restockGroup) return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    if (!event.data || event.data.sectionId !== sectionId) return;
    var available = !!(event.data.variant && event.data.variant.available);
    addToCartGroup.hidden = !available;
    restockGroup.hidden = available;
  });
});
